export default __webpack_public_path__ + "static/aurelien-c72a595ebd5260a4925e28db75633a2f.jpeg";